import request from '@/utils/request'
const url = 'index.php/websiteInst/api/websiteInst/'



//合作单位，友情链接
export function GetCooperList(query) {
    return request({
        url: url + 'Cooperation/GetCooperList',
        method: 'get',
        params: query
    })
}

//官网配置
export function GetIdByInfo(id) {
    return request({
        url: url + 'System/GetIdByInfo',
        method: 'get',
        params: {id}
    })
}
//机构列表
export function GetInstAllByPage(data) {
    return request({
        url: url + 'Cooperation/GetInstAllByPage',
        method: 'get',
        params: data
    })
}